import Button from "@common/components/Button";
import Grid from '@mui/material/Grid2';
import { canEditRole } from "@common/utils/user";
import { Typography } from "@mui/material";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import React from "react";
import { useTranslation } from "react-i18next";
import useRole from "../hooks/useRole";

interface ActionsPanelProps {}

const ActionsPanel = ({}: ActionsPanelProps): React.JSX.Element => {
  const { t } = useTranslation();
  const { role, saveChanges, cancelChanges, isValid } = useRole();
  const [user] = useAuthenticatedUser();
  const canEdit = canEditRole(user);

  return (
    <Grid
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 1.5),
      })}>
      <Grid
        container
        direction="row"
        wrap="nowrap"
        sx={{ width: '100%', justifyContent: "space-between" }}
      >
        <Typography sx={{
          alignSelf: "center"
        }}>
          {role?.id === undefined ? t("Add Role") : t("Edit Role")}
        </Typography>
        <Grid sx={(theme) => ({ "& > button": { mx: theme.spacing(0.5) } })}>
          {canEdit ? (
            <>
              <Button
                variant="contained"
                color="white"
                disabled={!isValid || !role || !canEdit}
                onClick={saveChanges}
              >
                {role?.id === undefined ? t("Add") : t("Save")}
              </Button>
              <Button variant="outlined" color="greyed" onClick={cancelChanges}>
                {t("Cancel")}
              </Button>
            </>
          ) : (
            <Button variant="outlined" color="greyed" onClick={cancelChanges}>
              {t("Close")}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ActionsPanel;
